<div *ngIf="session !== undefined" [ngSwitch]="session.sessionType">
  <app-play-qcm *ngSwitchCase="sessionType.QCM" [session]="session"></app-play-qcm>
  <app-play-thread *ngSwitchCase="sessionType.ProblemAnalysis" [session]="session"></app-play-thread>
  <app-play-solution-generation-thread *ngSwitchCase="sessionType.SolutionGeneration" [session]="session"></app-play-solution-generation-thread>
  <div *ngSwitchDefault>
    Non implémenté
  </div>
</div>
